import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Spinner,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  VStack,
  Text,
} from '@chakra-ui/react';
import Slideshow from '../components/Slideshow';

const Gallery = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGallery = async () => {
      try {
        setLoading(true);
        setError(null);

        // Recupera i dati dalla galleria dal CMS Strapi (include anche evento)
        const response = await axios.get('/api/galleries?sort=createdAt:desc');

        if (response.data && response.data.data) {
          // Normalizza i dati: se è un array, usa direttamente, altrimenti convertilo in array
          const dataArray = Array.isArray(response.data.data)
            ? response.data.data
            : [response.data.data];

          // Trasforma i dati nel formato atteso dal componente Slideshow
          // Gestisce sia slide di tipo immagine che slide di tipo dati (events, stats, goal, text)
          const images = dataArray
            .filter((item) => {
              // Include slide di tipo dati (events, stats, goal, text) o slide con media valido
              if (
                item.slideType === 'events' ||
                item.slideType === 'stats' ||
                item.slideType === 'goal' ||
                item.slideType === 'text'
              ) {
                return true;
              }
              return item.media && item.media.url;
            })
            .map((item) => {
              // Se è una slide di tipo dati, include anche il media per lo sfondo
              if (
                item.slideType === 'events' ||
                item.slideType === 'stats' ||
                item.slideType === 'goal' ||
                item.slideType === 'text'
              ) {
                return {
                  id: item.id,
                  slideType: item.slideType,
                  title: item.title || '',
                  media: item.media, // Media per lo sfondo
                  event: item.event,
                  donationGoal: item.donationGoal, // Dati del donation goal
                  galleryText: item.galleryText, // Testo per slide di tipo text
                  urlLink: item.urlLink,
                  galleryId: item.galleryId,
                };
              }

              // Slide di tipo immagine
              return {
                id: item.id,
                slideType: item.slideType || 'image',
                url: item.media.url.startsWith('http')
                  ? item.media.url
                  : `${window.location.origin}${item.media.url}`,
                alt:
                  item.media.alternativeText ||
                  item.media.name ||
                  `Immagine ${item.id}`,
                title: item.title || '',
                event: item.event,
                galleryText: item.galleryText, // Includi galleryText anche per slide di tipo image
                urlLink: item.urlLink,
                galleryId: item.galleryId,
                ...item.media,
              };
            });

          setGalleryImages(images);
        } else {
          setGalleryImages([]);
        }
      } catch (err) {
        console.error('Errore nel recupero della galleria:', err);
        setError(
          'Si è verificato un errore nel caricamento della galleria. Riprova più tardi.'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchGallery();
  }, []);

  if (loading) {
    return (
      <Box
        height="100vh"
        width="100vw"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="gray.800"
      >
        <VStack spacing={4}>
          <Spinner size="xl" color="white" />
          <Text color="white" fontSize="lg">
            Caricamento galleria...
          </Text>
        </VStack>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        height="100vh"
        width="100vw"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="gray.800"
        p={4}
      >
        <Alert status="error" maxWidth="500px" borderRadius="md">
          <AlertIcon />
          <Box>
            <AlertTitle>Errore!</AlertTitle>
            <AlertDescription>{error}</AlertDescription>
          </Box>
        </Alert>
      </Box>
    );
  }

  return <Slideshow images={galleryImages} interval={10000} />;
};

export default Gallery;
